/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
import { getHookContext } from "../context/SompoContext";
import { setLocalValue, removeLocalValue } from "../storage";
import { LoginResponse } from "../api/LoginService";

export const STORAGE_KEY_ACCESS_TOKEN = "portal-token-access";
export const STORAGE_KEY_REFRESH_TOKEN = "portal-token-refresh";

export const login = (response: LoginResponse) => {
    setLocalValue(STORAGE_KEY_ACCESS_TOKEN, response.accessToken);
    setLocalValue(STORAGE_KEY_REFRESH_TOKEN, response.refreshToken);
    getHookContext().setHomeVisited(false);
};

export const logout = () => {
    getHookContext().clear();
    removeLocalValue(STORAGE_KEY_ACCESS_TOKEN);
    removeLocalValue(STORAGE_KEY_REFRESH_TOKEN);
};
